import { useNavigate } from 'react-router-dom'

const LatestBlog = () => {
    const navigate = useNavigate()
    return (
        <>
            {/* <!-- ====================================== Section Ten ===================================== --> */}
            {/* <section className="section-ten-blog">
                <div className="container">
                    <h2
                        className="section-heading-text latestProjects-heading p-0"
                        data-aos="fade-up"
                    >
                        Últimos <span>Artigos & Reflexões</span>
                    </h2>

                    <div className="row home-blog-row">

                        
                        <div
                            className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 blog-col"
                            data-aos="fade-up"
                            onClick={() => navigate("/")}
                        >
                            <div className="img-blog-content-mix position-relative">
                                <h2 className="tips">Reflexões</h2>
                                <img className="blog-img" src={BlogImg1} alt="blog-img1" />
                            </div>
                            <h3 className="blog-text">
                                Por que é tão difícil tomar decisões importantes?
                            </h3>
                            <p className="blog-sub-text">
                                Muitas vezes o problema não é a decisão em si, mas o excesso de
                                informações, expectativas e medos acumulados. Entenda como ganhar
                                clareza antes de dar o próximo passo.
                            </p>
                        </div>

                        
                        <div
                            className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 blog-col"
                            data-aos="fade-up"
                            onClick={() => navigate("/")}
                        >
                            <div className="img-blog-content-mix position-relative">
                                <h2 className="tips">Vida & Propósito</h2>
                                <img className="blog-img" src={BlogImg2} alt="blog-img2" />
                            </div>
                            <h3 className="blog-text">
                                Como identificar o que realmente faz sentido para você
                            </h3>
                            <p className="blog-sub-text">
                                No meio da pressa e das cobranças externas, muitas pessoas se
                                desconectam do que é essencial. Aqui você aprende a resgatar sua
                                própria direção.
                            </p>
                        </div>

                        
                        <div
                            className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 blog-col"
                            data-aos="fade-up"
                            onClick={() => navigate("/")}
                        >
                            <div className="img-blog-content-mix position-relative">
                                <h2 className="tips">Autoridade</h2>
                                <img className="blog-img" src={BlogImg3} alt="blog-img3" />
                            </div>
                            <h3 className="blog-text">
                                Como criar movimentos reais quando você se sente estagnado
                            </h3>
                            <p className="blog-sub-text">
                                A sensação de estar parado é mais comum do que parece. Aqui você
                                entende como transformar insights em ações que realmente mudam sua
                                rotina.
                            </p>
                        </div>

                    </div>
                </div>
            </section> */}
        </>
    )
}

export default LatestBlog
